export default "__VITE_ASSET__BqHgM3rY__"